import React from 'react';
import { Logo } from './Logo';
export function PresentationLogo() {
  return <div className="pointer-events-none absolute right-4 top-4 z-[45] rounded-xl bg-white/90 p-1.5 shadow-sm ring-1 ring-black/5 backdrop-blur" data-id="element-34" data-mp="3v5wpnoao0e42">
      <Logo width={30} height={30} alt="Snakker logo" data-id="element-35" data-mp="3hdqdseejotaf" />
    </div>;
}